import { Navigate, Outlet } from "react-router-dom";

import { useAuthStore } from "src/store/authStore";


export default function PublicLayout() {
  const { authToken } = useAuthStore();

    // ✅ Single check protects ALL routes in this group
  if (authToken) {
    return <Navigate to="/statistics" replace />;
  }

  return (
    <>
      {/* Protected Layout will be designed here */}
      {/* <nav>Navigation</nav> */}
      <div className="d-flex flex-fill flex-column">
        <Outlet /> {/* All child routes render here */}
      </div>
    </>
  );
}
